export default "__VITE_ASSET__Cd14uSrH__"